import { useQuery } from '@tanstack/react-query';
import { JobApi } from '@/features/upload/JobApi';
import { JOB_POLL_ACTIVE_INTERVAL_MS } from '@/lib/constants/upload';

/** Shared query key for job data — all consumers share this. */
export const JOB_DATA_QUERY_KEY = (cId: number) => ['jobs', cId] as const;

/**
 * Shared job data fetcher. One API call per interval, regardless of
 * how many features are polling (video uploads, poster processing,
 * clips, merges, overlays, etc.).
 *
 * TanStack Query deduplicates by query key — multiple consumers with
 * the same cId share ONE API call. If ANY consumer has enabled: true,
 * the query runs.
 */
export function useJobData(cId: number | null, enabled: boolean) {
  const canRun = cId != null && enabled;

  return useQuery({
    queryKey: JOB_DATA_QUERY_KEY(cId ?? 0),
    queryFn: () => JobApi.getJobs(cId!),
    enabled: canRun,
    refetchInterval: canRun ? JOB_POLL_ACTIVE_INTERVAL_MS : false,
    staleTime: 0,
  });
}
